export const localhostBugGuide = {
  title: 'Show someone a bug in an app running on your computer',
  slug: 'record-localhost-bug-share-evidence',
  date: '2026-10-07',
  description: 'Show a bug in your local app with a short recording. Follow simple steps to capture the problem, explain what you expected, and share it with someone who can help.',
} as const;
